export const colorPalettes = [
  {
    speedometerType: 1,
    name: "viridisAccuracy",
    colors: [
      "#471365",
      "#482374",
      "#46327e",
      "#424086",
      "#3d4e8a",
      "#365c8d",
      "#31688e",
      "#2c738e",
      "#277f8e",
      "#238a8d",
      "#1f968b",
      "#1fa187",
      "#26ad81",
      "#35b779",
      "#4ac16d",
      "#65cb5e",
      "#81d34d",
      "#a0da39",
      "#c0df25",
      "#dfe318",
    ],
  },
  {
    name: "plasmaCompare",
    speedometerType: 2,
    colors: [
      "#2a0593",
      "#3f049c",
      "#5302a3",
      "#6600a7",
      "#7801a8",
      "#8b0aa5",
      "#9c179e",
      "#ab2494",
      "#b83289",
      "#c5407e",
      "#d14e72",
      "#db5c68",
      "#e56a5d",
      "#ed7953",
      "#f48849",
      "#f99a3e",
      "#fdab33",
      "#febd2a",
      "#fcd025",
      "#f7e425",
    ],
  },
  {
    name: "twilightDiffClass",
    speedometerType: 3,
    colors: [
      "#3f1251",
      "#521c79",
      "#5c359a",
      "#5e53ae",
      "#616fb9",
      "#6989be",
      "#7ca2c2",
      "#99b8c8",
      "#bccbd1",
      "#dad8df",
      "#e0d6d9",
      "#d6c2b6",
      "#cda78e",
      "#c6896c",
      "#bc6b59",
      "#ae5051",
      "#9a3750",
      "#7f2350",
      "#60184a",
      "#42123e",
    ],
  },
  {
    name: "SpectralDiff",
    colors: [
      "#496aaf",
      "#3585bb",
      "#47a0b3",
      "#60bba8",
      "#7ecca5",
      "#a2d9a4",
      "#bfe5a0",
      "#daf09a",
      "#edf8a3",
      "#f9fcb5",
      "#fff7b2",
      "#fee999",
      "#fed683",
      "#fdbf6f",
      "#fca55d",
      "#f7844e",
      "#f06744",
      "#e2514a",
      "#d23a4e",
      "#b81e48",
    ],
  },
];
